module.exports = __webpack_public_path__ + "static/media/testImg.ce2f5a37.jpg";